import { api, handleError } from "./baseApi";

export async function getAllCities(filters = {}) {
  try {
    const { data } = await api.get("/city", {
      params: {
        page_no: filters.page_no,
        limit: filters.limit,
        city_name: filters.city_name,
      },
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function createCity(city_name) {
  try {
    const { data } = await api.post("/city",{city_name});
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function updateCity(cityId,payload) {
  try {
    const { data } = await api.put(`/city/${cityId}`, { payload });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function getCityByID(cityId) {
  try {
    const { data } = await api.get(`/city/${cityId}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}
export async function deleteCity(cityId) {
  try {
    const { data } = await api.delete(`/city/${cityId}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}
